var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-header-index-wide" },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", hight: "50%" },
              attrs: { sm: 24, md: 12, xl: 12 }
            },
            [
              _c("chart-card", {
                attrs: {
                  loading: _vm.loading,
                  title: "总销售额",
                  total: "￥126,560"
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", hight: "50%" },
              attrs: { sm: 24, md: 12, xl: 12 }
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "订单量",
                    total: _vm._f("NumberFormat")(8846)
                  }
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: { slot: "action", title: "指标说明" },
                      slot: "action"
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("div", [_c("mini-area")], 1),
                  _c("template", { slot: "footer" }, [
                    _vm._v("日订单量"),
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm._f("NumberFormat")("1234")))
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", hight: "50%" },
              attrs: { sm: 24, md: 12, xl: 12 }
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "订单量",
                    total: _vm._f("NumberFormat")(8846)
                  }
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: { slot: "action", title: "指标说明" },
                      slot: "action"
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("div", [_c("mini-area")], 1),
                  _c("template", { slot: "footer" }, [
                    _vm._v("日订单量"),
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm._f("NumberFormat")("1234")))
                    ])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "a-col",
            {
              style: { marginBottom: "24px", hight: "50%" },
              attrs: { sm: 24, md: 12, xl: 12 }
            },
            [
              _c(
                "chart-card",
                {
                  attrs: {
                    loading: _vm.loading,
                    title: "支付笔数",
                    total: _vm._f("NumberFormat")(6560)
                  }
                },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: { slot: "action", title: "指标说明" },
                      slot: "action"
                    },
                    [_c("a-icon", { attrs: { type: "info-circle-o" } })],
                    1
                  ),
                  _c("div", [_c("mini-bar", { attrs: { height: 40 } })], 1),
                  _c("template", { slot: "footer" }, [
                    _vm._v("转化率 "),
                    _c("span", [_vm._v("60%")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }